import { ReferralLink } from "types/affiliation.types";

export enum AffiliationTabs {
  OVERVIEW = "overview",
  REFERRAL_LINKS = "referral-links",
  REFERRED_USERS = "referred-users",
  EXISTING_USERS = "existing-users",
  EARNINGS = "earnings",
  PAYOUTS = "payouts",
}

export enum ReferralLinksStatistics {
  NUM_OF_LINKS = "links.statistics.num_of_links",
  TOTAL_CLICKS = "links.statistics.total_clicks",
  REFERRED_USERS = "links.statistics.referred_users",
  PAID_USERS = "links.statistics.paid_users",
}

export enum ReferredUsersStatistics {
  REGISTERED_USERS = "users.statistics.registered_users",
  TOTAL_EARNED = "users.statistics.total_earned",
}

export enum ExistingUsersStatistics {
  EXISTING_USERS = "users.statistics.existing_users",
  TOTAL_EARNED = "users.statistics.total_earned",
}

export enum EarningsPieChartKeys {
  AMOUNT_EARNED = "earnings.pie_chart_keys.amount_earned",
  AMOUNT_NOT_CONFIRMED = "earnings.pie_chart_keys.amount_not_confirmed",
}

export enum PayoutsStatistics {
  PENDING_PAYOUTS = "payouts.statistics.pending_payouts",
  AMOUNT_AWAITING_APPROVAL = "payouts.statistics.awaiting_approval",
  PROCESSED_PAYOUTS = "payouts.statistics.processed_payouts",
  PAID_TO_DATE = "payouts.statistics.paid_to_date",
}

export type ReferralLinksStatisticsValues = Pick<
  ReferralLink,
  "clicks" | "registered_users" | "paid_users" | "referral_code"
>;

export type UsersStatisticsTypes =
  | ReferredUsersStatistics
  | ExistingUsersStatistics;

export type StatisticsTypes =
  | ReferralLinksStatistics
  | ReferredUsersStatistics
  | ExistingUsersStatistics
  | PayoutsStatistics;
